import initCommon from './application.js'
import initSwiper from './initializers/Swiper.js'
import initTravelInfoAccordion from './initializers/TravelInfoAccordion.js'
import initTravelTabs from './initializers/TravelTabs.js'
import initYoutubePlayer from './initializers/YoutubePlayer.js'

const initStatic = () => {
  initCommon()
  initSwiper()
  initTravelInfoAccordion()
  initTravelTabs()
  initYoutubePlayer()
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initStatic)
} else {
  initStatic()
}
